/**
 * Where the detail pages drop from two columns to one.
 *
 * One constant, not one per page: the shell and the pages that read their own
 * collapse all have to answer at the same width, and a page that disagreed would
 * stack its sidebar while the shell still drew two columns.
 *
 * `md` because the sidebar is a fixed 400px: below that breakpoint the primary
 * column falls under the 676px it gets in the desktop frame and the invite list
 * starts to squeeze.
 */
export const COLLAPSE_BREAKPOINT = 'md';
